import { useState, useCallback } from "react";
import { Nav, Footer } from "./components/shared-nav";
import Playground from "./components/playground";
import Benchmark from "./components/benchmark";
import Competitions from "./components/competitions";
import CompetitionDetail from "./components/competition-detail";
import ShareBoard from "./components/share-board";
import { ThemeProvider } from "./components/theme-provider";

type PageView = "competitions" | "playground" | "benchmark" | "competition-detail" | "share-board";

export default function App() {
  const [pageView, setPageView] = useState<PageView>("competitions");
  const [selectedCompetitionId, setSelectedCompetitionId] = useState<string>("");
  const [openShareBoardPublish, setOpenShareBoardPublish] = useState(false);
  const [openShareBoardItemId, setOpenShareBoardItemId] = useState<string | undefined>(undefined);

  const navigateTo = useCallback((page: PageView) => {
    setPageView(page);
    if (page === "share-board") {
      setOpenShareBoardPublish(false);
      setOpenShareBoardItemId(undefined);
    }
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const navigateToCompetitionDetail = useCallback((id: string) => {
    setSelectedCompetitionId(id);
    setPageView("competition-detail");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const navigateToShareBoardWithPublish = useCallback(() => {
    setOpenShareBoardPublish(true);
    setOpenShareBoardItemId(undefined);
    setPageView("share-board");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const navigateToShareBoardItem = useCallback((itemId: string) => {
    setOpenShareBoardPublish(false);
    setOpenShareBoardItemId(itemId);
    setPageView("share-board");
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <ThemeProvider>
      <div className="min-h-screen w-full" style={{ backgroundColor: 'var(--brand-bg)' }}>
        {/* Nav */}
        <Nav
          variant="profile"
          onCompetitionsClick={() => navigateTo("competitions")}
          onCompetitionDetailClick={() => navigateTo("competition-detail")}
          onPlaygroundClick={() => navigateTo("playground")}
          onBenchmarkClick={() => navigateTo("benchmark")}
          onShareBoardClick={() => navigateTo("share-board")}
          activePage={pageView}
        />

        {/* Content */}
        {pageView === "competitions" && (
          <Competitions
            onCompetitionClick={navigateToCompetitionDetail}
            onPlaygroundClick={() => navigateTo("playground")}
          />
        )}
        {pageView === "competition-detail" && (
          <CompetitionDetail
            competitionId={selectedCompetitionId}
            onBack={() => navigateTo("competitions")}
          />
        )}
        {pageView === "playground" && (
          <Playground 
            onNavigateToShareBoard={() => navigateToShareBoardWithPublish()}
            onViewShareItem={(itemId) => navigateToShareBoardItem(itemId)}
          />
        )}
        {pageView === "benchmark" && <Benchmark />}
        {pageView === "share-board" && (
          <ShareBoard 
            openPublish={openShareBoardPublish} 
            onPublishModalClose={() => setOpenShareBoardPublish(false)}
            openItemId={openShareBoardItemId}
          />
        )}
      </div>
    </ThemeProvider>
  );
}